<template>
<div class="chapter">
<div class="inner_page">
<div class="small">
<p>Copyright © 2005 by David E. Murphy.</p>
<p>All rights reserved.</p>
<p>This book may not be reproduced, in whole or in part, including illustrations, in any form<br/>(beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and<br/>except by reviewers for the public press), without written permission from the publishers.<br/><br/></p>
<p>Designed by James J. Johnson and set in New Aster type by Keystone Typesetting, Inc.<br/>Printed in the United States of America by Vail-Ballou Press.<br/><br/></p>
<p><i>Library of Congress Cataloging-in-Publication Data</i><br/><br/></p>
<p>Murphy, David E., 1921–</p>
<p>What Stalin knew : the enigma of Barbarrosa / David E. Murphy.</p>
<p>   p.   cm.</p>
<p>Includes bibliographical references and index.</p>
<p><span class="small">ISBN</span> 0-300-10780-3 (cloth : alk. paper)<br/><br/></p>
<p>1. World War, 1939–1945—Campaigns—Eastern Front. 2. Stalin, Joseph, 1879–1953—<br/>Military leadership. 3. Soviet Union—Politics and government—1936–1953. I. Title.<br/><span class="small">D</span>764.M845 2005<br/>940.54′217—dc22<br/><br/></p>
<p class="right">2004065916<br/><br/></p>
<p>A catalogue record for this book is available from the British Library.<br/><br/></p>
<p>The paper in this book meets the guidelines for permanence and durability of the<br/>Committee on Production Guidelines for Book Longevity of the Council on Library<br/>Resources.<br/><br/></p>
<p>10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?b895a69e